import { useState } from "react"

import Choices from "./Choices/Choices"
import Result from "./Result/Result"



import "./Game.css"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { choiceSelector } from "../../Redux/Game/gameSelector"


const Game = ({choice}) => {


    return (

        !choice?.variant ?
            <Choices></Choices>
            :
            <Result choice={choice}></Result>

    )



}

const mapStateToProps =createStructuredSelector({
    choice : choiceSelector
})

export default connect(mapStateToProps)(Game)